import { EMAIL_STATISTICS_API } from 'modules/email-statistics/api/email-statistics-api'
import {
  EmailStatisticsFilterInterface,
  EmailStatisticsTableApiInterface,
} from 'modules/email-statistics/types/email-statistics-interface'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string'

interface UseEmailStatisticTableInterface extends SwrPaginationInterface {
  filter: EmailStatisticsFilterInterface
}

export const useEmailStatisticsTable = ({
  limit,
  pagination,
  filter,
}: UseEmailStatisticTableInterface) => {
  const { user } = useUser()

  const { fetcher } = useFetch<RequestMethodsEnum.get, EmailStatisticsTableApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const filterApi = `${filter.dateSince !== null ? `&filter[dateSince]=${filter.dateSince}` : ''}${
    filter.dateTill !== null ? `&filter[dateTill]=${filter.dateTill}` : ''
  }`

  const { data: emailDashboardTable } = useControlledSwr(
    () => [
      `${EMAIL_STATISTICS_API}/list?${getPaginationQueryString({ limit, pagination })}${filterApi}`,
      RequestModuleEnum.CampaignStep,
    ],
    fetcher,
    undefined,
    !!user && filter.dateTill !== null,
  )

  return { emailDashboardTable }
}
